import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/providers/common.service';

@Component({
  selector: 'app-customers-tpn-listv2',
  templateUrl: './customers-tpn-listv2.component.html',
  styleUrls: ['./customers-tpn-listv2.component.scss']
})
export class CustomersTpnListv2Component implements OnInit {

  customerWiseTpnList:any;
  spName: any;
  @Input() customerWiseTpnCount :any;
  @Input() salesPersonName = '';
  @Input() SPCustShowDiv :boolean;
  @Input() timePeriod = '';
  buttonLoader: any= false;
  showDiv = false;
  filterText = ''; 
  filteredCustomers: any;
  customerDbaList: string[] = [];
  customersalesList: string[] = [];
  minTPN: number | null = null;
  maxTPN: number | null = null;
  rangeValues: number[] = [0, 0]; 
  selectedCustomer: string | null = null;
  salesperson: string | null = null;
  selectedDateFilter: string | null = null;
  selectDate = ['Before 30 Days','Last 30 Days']
  constructor(public modal: NgbActiveModal, private ngbModal:NgbModal,private commonService: CommonService) { }

  ngOnInit(): void {
    console.log("this.customerWiseTpnCount", this.customerWiseTpnCount);
    // for (let obj of this.customerWiseTpnCount) {
    //   for (let key in obj) {
    //     obj["st"]
    //     if (key == "merchant_to_stores.dba") {
    //       obj["storeDba"] = obj[key];
    //     }
    //     obj["merchantName"] = obj["firstName"] + " " + obj["lastName"];
    //     obj["storeName"] = obj["merchant_to_stores.firstName"] + " " + obj["merchant_to_stores.lastName"];
    //     if (key == "merchant_to_stores.store_to_tpns.tpn") {
    //       obj["tpn"] = obj[key];
    //     }
    //     if (key == "merchant_to_stores.store_to_tpns.merchantInfo") {
    //       obj["merchantInfo"] = JSON.parse(obj[key]);
    //       obj["tpnDba"] = !isEmpty(obj["merchantInfo"])? obj["merchantInfo"]["dba"] : '';
    //     }
    //   }
    // }
    this.customerWiseTpnList = this.customerWiseTpnCount;
    this.filteredCustomers = [...this.customerWiseTpnList];
    this.customerDbaList = this.customerWiseTpnList.map(c => c.dba); 
    this.customersalesList = this.customerWiseTpnCount.map(c => c.firstName === null ? "N/A": c.firstName)
    this.customersalesList = Array.from(new Set( this.customersalesList));
    // this.calculateTPNRange();
    this.spName = this.salesPersonName;
    if(this.SPCustShowDiv) {
      this.showDiv = true;
    }
  }

  downloadISOdata(){
    this.buttonLoader = true;
    let fileName = "customers_list.xlsx";
    let worksheetData = {
      "worksheet" : [
        {
          "name": 'Customers list',
          "columns":  [
            //{ header: "ISO", key: "createdBy", width: 25 },
            { header: "ISO/Agent DBA", key: "dba", width: 25 },
            { header: "Created On", key: "__time", width: 25 },
            { header: "Salesperson", key: "firstName", width: 25 },
            { header: "City", key: "city", width: 25 },
            { header: "State", key: "state", width: 25 },
            //{ header: "Created On", key: "formattedCreatedAt", width: 30},
            { header: "TPN count", key: "tpn", width: 10},
            //{ header: "Last Transaction Date", key: "formattedLastTxDate", width: 30},
          ],
          "rows": this.filteredCustomers,  
          "isRow": 0,
          frozen:true,
        }
      ],
      "fileName": fileName
    };

    this.commonService.downloadAsExcel(worksheetData).then(res => {
      // this.modalReference.close();
      this.buttonLoader = false;
    });
  }


  filterCustomers() {
    if (this.selectedCustomer || this.salesperson || this.rangeValues) {

      this.filteredCustomers = this.customerWiseTpnList.filter(customer => {
        const matchesCustomer = this.selectedCustomer
          ? customer.dba?.toLowerCase().includes(this.selectedCustomer.toLowerCase()) : true;

        const matchesSalesperson = this.salesperson
        ? (this.salesperson === "N/A"
            ? customer.firstName === null || customer.firstName.trim() === ""
            : customer.firstName?.toLowerCase().includes(this.salesperson.toLowerCase()))
        : true;
        const matchesTPN = 
        (this.minTPN === null || customer.tpn >= this.minTPN) &&
        (this.maxTPN === null || customer.tpn <= this.maxTPN);
        const matchesDateFilter = this.selectedDateFilter ? this.filterByDate(customer.__time) : true;
        return matchesCustomer && matchesSalesperson && matchesTPN && matchesTPN && matchesDateFilter;
      });

    }
    else {
      this.filteredCustomers = [...this.customerWiseTpnList];
    }
  }

  filterByDate(createdOn: string): boolean {
    if (!createdOn) return false;
    
    const createdDate = new Date(createdOn);
    const today = new Date();
    const daysDifference = (today.getTime() - createdDate.getTime()) / (1000 * 3600 * 24);

    if (this.selectedDateFilter === 'Before 30 Days') {
      return daysDifference > 30;
    } else if (this.selectedDateFilter === 'Last 30 Days') {
      return daysDifference <= 30;
    }
    return true;
  }

}
